module.exports = __webpack_public_path__ + "media/images/default/pages/about/main/34436-6322d36d4629baf109b82dcdfa276cda.svg";